import React from 'react';
import { Route } from 'react-router-dom';
import QuotationPageRoute from './QuotationPageRoute';

const basePath = '/v2/quotation';

export default (
  <Route path={`${basePath}/:quotationId`}>
    <QuotationPageRoute />
  </Route>
);
